module.exports = __webpack_public_path__ + "img/location.f93b9af4.png";